export const Links = {
    BASE_URL_WITHOUT_TENANT: process.env.NODE_ENV === 'development' ? 'http://10.0.0.2:8003/api' : 'https://yuzenkuzu.com/api',
    // BASE_URL_WITHOUT_TENANT: process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api' : 'https://yuzenkuzu.com/api',
    // BASE_URL_WITHOUT_TENANT: 'https://yuzenkuzu.com/api',
};

export default Links;
